import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Info } from "react-feather";
import EmployeePhoto from "./EmployeePhoto";
import { useGetPassTypeByIdQuery } from "AppQuries/master/PassType/pass-type";
import { format } from "date-fns";
import { Link } from "react-router-dom";
import ImageWithBasePath from "core/img/imagewithbasebath";

const PassDetails = ({ employee }) => {
  const { data: passType } = useGetPassTypeByIdQuery({
    companyCode: employee?.companyCode,
    code: employee?.passTypeDetails?.[0]?.passCode || 0,
  });

  const [tableFields, setTableFields] = useState({});

  useEffect(() => {
    if (passType?.length) {
      setTableFields(passType[0]?.dataFields.split(","));
    }
  }, [passType]);

  return (
    <div className="view-employee-box mb-3">
      <div className="view-title">
        <h4>Pass Details</h4>
      </div>
      <div className="view-employee-content table-responsive">
        {Object.keys(tableFields).length && (
          <div className="row">
            <table className="table ">
              <thead>
                <tr>
                  {tableFields?.includes("nricNumber") && <th>NRIC Number</th>}
                  {tableFields?.includes("photoIdBarcode") && (
                    <th>Photo Id Barcode</th>
                  )}
                  {tableFields?.includes("issuedDate") && <th>Issued Date</th>}
                  {tableFields?.includes("sector") && <th>Sector</th>}
                  {tableFields?.includes("dateOfApplication") && (
                    <th>Date of Application</th>
                  )}
                  {tableFields?.includes("idExpiryDate") && (
                    <th>ID Expiry Date</th>
                  )}
                  {tableFields?.includes("sPassNumber") && (
                    <th>S Pass Number</th>
                  )}
                  {tableFields?.includes("workPermitNumber") && (
                    <th>Work Permit Number</th>
                  )}
                  {tableFields?.includes("workPermitRenewalDate") && (
                    <th>Work Permit Renewal Date</th>
                  )}
                  {tableFields?.includes("levyTypes") && <th>Levy Types</th>}
                  {tableFields?.includes("levyAmountTypes") && (
                    <th>Levy Amount Type</th>
                  )}
                  {tableFields?.includes("levyAmount") && <th>Levy Amount</th>}
                  {tableFields?.includes("pcpExpiryDate") && (
                    <th>PCP Expiry Date</th>
                  )}
                  {tableFields?.includes("pcpClinic") && <th>PCP Clinic</th>}
                  {tableFields?.includes("pcpCtypeOfVisalinic") && (
                    <th>Type of Visa</th>
                  )}
                  {tableFields?.includes("remarks") && <th>Remarks</th>}
                </tr>
              </thead>
              <tbody>
                {employee?.passTypeDetails?.map((pass) => (
                  <tr key={pass?.passCode}>
                    {tableFields?.includes("nricNumber") && (
                      <td>{pass?.nricNumber}</td>
                    )}
                    {tableFields?.includes("photoIdBarcode") && (
                      <td>{pass?.photoIdBarcode}</td>
                    )}
                    {tableFields?.includes("issuedDate") && (
                      <td>
                        {pass?.issuedDate === "" || pass?.issuedDate === null
                          ? ""
                          : format(new Date(pass?.issuedDate), "yyyy-MM-dd")}
                      </td>
                    )}
                    {tableFields?.includes("sector") && <td>{pass?.sector}</td>}
                    {tableFields?.includes("dateOfApplication") && (
                      <td>
                        {pass?.dateOfApplication === "" ||
                        pass?.dateOfApplication === null
                          ? ""
                          : format(
                              new Date(pass?.dateOfApplication),
                              "yyyy-MM-dd"
                            )}
                      </td>
                    )}
                    {tableFields?.includes("idExpiryDate") && (
                      <td>
                        {pass?.idExpiryDate === "" ||
                        pass?.idExpiryDate === null
                          ? ""
                          : format(new Date(pass?.idExpiryDate), "yyyy-MM-dd")}
                      </td>
                    )}
                    {tableFields?.includes("sPassNumber") && (
                      <td>{pass?.sPassNumber}</td>
                    )}
                    {tableFields?.includes("workPermitNumber") && (
                      <td>{pass?.workPermitNumber}</td>
                    )}
                    {tableFields?.includes("workPermitRenewalDate") && (
                      <td>
                        {pass?.workPermitRenewalDate === "" ||
                        pass?.workPermitRenewalDate === null
                          ? ""
                          : format(
                              new Date(pass?.workPermitRenewalDate),
                              "yyyy-MM-dd"
                            )}
                      </td> //pass?.workPermitRenewalDate}</td>
                    )}
                    {tableFields?.includes("levyTypes") && (
                      <td>{pass?.levyTypes}</td>
                    )}
                    {tableFields?.includes("levyAmountTypes") && (
                      <td>{pass?.levyAmountTypes}</td>
                    )}
                    {tableFields?.includes("levyAmount") && (
                      <td>{pass?.levyAmount}</td>
                    )}
                    {tableFields?.includes("pcpExpiryDate") && (
                      <td>{pass?.pcpExpiryDate}</td>
                    )}
                    {tableFields?.includes("pcpClinic") && (
                      <td>{pass?.pcpClinic}</td>
                    )}
                    {tableFields?.includes("pcpCtypeOfVisalinic") && (
                      <td>{pass?.pcpCtypeOfVisalinic}</td>
                    )}
                    {tableFields?.includes("remarks") && (
                      <td>{pass?.remarks}</td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        {/* <div className="row">
          {employee?.passTypeDetails?.[0]?.frontImage !== null && (
            <div className="col-md-6">
              <div className="slider-product-details">
                <div className="owl-carousel owl-theme product-slide">
                  <div className="slider-product">
                    <img
                      src={employee?.passTypeDetails?.[0]?.frontImage}
                      alt="Pass Front Image"
                      width={60}
                    />
                    <h4>Front Image</h4>
                  </div>
                </div>
              </div>
            </div>
          )}
          {employee?.passTypeDetails?.[0]?.backImage !== null && (
            <div className="col-md-6">
              <div className="slider-product-details">
                <div className="owl-carousel owl-theme product-slide">
                  <div className="slider-product">
                    <img
                      src={employee?.passTypeDetails?.[0]?.backImage}
                      alt="Pass Back Image"
                      width={60}
                    />
                    <h4>Back Image</h4>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div> */}
      </div>
    </div>
  );
};

PassDetails.propTypes = {
  employee: PropTypes.object.isRequired,
};

export default PassDetails;
